<div class="d-inline-block">
    <app-tag *ngFor="let tag of tags"
             class="ms-2"
             [tag]="tag"
             [selected]="selected.includes(tag)"
             (clicked)="onTagClick($event)"
    ></app-tag>
</div>
